import ListPage from './ListPage';
import CreatePage from './CreatePage';
import DetailsPage from './DetailsPage';

export default {
  ListPage,
  CreatePage,
  DetailsPage
};
